import axios from "axios";
import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const fetch = createAsyncThunk(
  "weatherApi/fetchWeather",
  async (coords) => {
    const response = await axios.get(
      `http://www.omdbapi.com/?apikey=72f4d5f2&s=movie&y=1997&page=5`
    );
  
    return response.data  ;
  }
);
const slice = createSlice({
  name: "sliceReducer",
  initialState: {
    result: {},
   
    isLoading: false,
  },
  reducers: {
    changeResult: (state, action) => {
      state.result =fetch ;
    },
},
 extraReducers(builder) {
    builder
      .addCase(fetch.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(fetch.fulfilled, (state, action) => {
        state.isLoading = false;
        state.weather = action.payload;
      })
      .addCase(fetch.rejected, (state, action) => {
        state.isLoading = false;
      });
  },

})
export const { changeresult } = slice.actions;
export default slice.reducer;
